<!-- Taxonomy Association modal starts -->
<app-modal [modalId]="'association-modal'" class="taxonomy-association" [modalSize]="'big'" [showFooter]="false">
    <modal-div class="title-text">
        Taxonomy Association
    </modal-div>

    <modal-div class="body-content">

    </modal-div>

</app-modal>
<!-- Taxonomy Association modal ends -->